import { render, staticRenderFns } from "./AssignGrid.vue?vue&type=template&id=fa7c891a&scoped=true&"
import script from "./AssignGrid.vue?vue&type=script&lang=js&"
export * from "./AssignGrid.vue?vue&type=script&lang=js&"
import style0 from "./AssignGrid.vue?vue&type=style&index=0&id=fa7c891a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7c891a",
  null
  
)

export default component.exports